import { useDispatch, useSelector } from 'react-redux';
import RoundedEditableImage from '../../components/rounded-editable-image/RoundedEditableImage';
import { getOrganizationById, isCropping } from '../organizations-reducer';
import { cropOrganizationPicture, updateOrganizationPicture } from '../organization-actions';
import styles from './edit-organization-image.module.less';
import RoundedImage from '../../components/RoundedImage';
import { showErrorModal } from '../../global-message/global-message-actions';

const EditOrganizationImage = ({ organizationId, imageSize, alt, editable }) => {
    const dispatch = useDispatch();

    const organization = useSelector((state) => getOrganizationById(state, organizationId));
    const isCroppingProfilePicture = useSelector(isCropping);

    const updatePicture = (file) => {
        return dispatch(updateOrganizationPicture(organizationId, file));
    };

    const cropHandler = (crop) => {
        return dispatch(cropOrganizationPicture(organizationId, crop));
    };

    const onDropRejected = () => {
        return dispatch(showErrorModal('Bildefilen du prøver å laste opp støttes ikke'));
    };

    if (!editable && !organization?.img_url) {
        return null;
    }

    if (!editable) {
        return (
            <div className={styles.wrapper}>
                <RoundedImage src={organization?.img_url} size={imageSize} alt={alt} />
            </div>
        );
    }

    return (
        <RoundedEditableImage
            updateImage={updatePicture}
            onDropRejected={onDropRejected}
            placeholderText="Logo"
            tmpImageUrl={organization?.img_tmp_url}
            imageUrl={organization?.img_url}
            wrapperClass={organization?.img_url ? styles.wrapper : styles.placeholderWrapper}
            cropHandler={cropHandler}
            imageSize={imageSize}
            isCropping={isCroppingProfilePicture}
            alt={alt}
        />
    );
};

export default EditOrganizationImage;
